import { render } from "./Quote.vue?vue&type=template&id=45569343&scoped=true"
import script from "./Quote.vue?vue&type=script&lang=ts"
export * from "./Quote.vue?vue&type=script&lang=ts"

import "./Quote.vue?vue&type=style&index=0&id=45569343&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-45569343"

export default script